import React, { useState, useEffect } from "react";
import "../CSS/Contact.css";

export default function Contact() {
  const [captcha, setCaptcha] = useState({});
  const [userAnswer, setUserAnswer] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    generateCaptcha();
  }, []);

  const generateCaptcha = () => {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha({ num1, num2, answer: num1 + num2 });
    setUserAnswer("");
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (parseInt(userAnswer) === captcha.answer) {
      alert("✅ Message Sent Successfully!");
      generateCaptcha();
    } else {
      setError("❌ Wrong Captcha. Try again!");
    }
  };

  return (
    <div className="contact-container">

      <section className="contact-top">
        <h1 className="contact-title">Get in Touch</h1>
        <p className="contact-subtitle">
          Have questions about our services? We're here to help you make the
          switch to smart, green energy.
        </p>

        <div className="info-cards">
          <div className="card">
            <div className="icon phone"></div>
            <h3> Phone</h3>
            <p>+91 11 1234 5678</p>
          </div>

          <div className="card">
            <div className="icon email"></div>
            <h3> Email</h3>
            <p>info@amphigreen.com</p>
          </div>

          <div className="card">
            <div className="icon address"></div>
            <h3> Address</h3>
            <p>
              1104, Tolstoy House, Atul Grove Road, Janpath, Connaught Place,
              New Delhi, Delhi 110001
            </p>
          </div>
        </div>
      </section>

      <section className="contact-bottom">
       
        <div className="contact-form">
          <h2>
            Send us a <span className="highlight">Message</span>
          </h2>
          <form onSubmit={handleSubmit}>
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Email Address" required />
            <input type="text" placeholder="Phone Number" required />
            <textarea placeholder="Your Message" rows="5" required></textarea>

            <div className="captcha-box">
              <label>
                Solve: {captcha.num1} + {captcha.num2} = ?
              </label>
              <input
                type="number"
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                required
              />
              {error && <p className="error">{error}</p>}
            </div>

            <button type="submit" className="send-btn">
              Send Message ➤
            </button>
          </form>
        </div>

        <div className="contact-map">
          <h2>
            Visit Our <span className="highlight">Office</span>
          </h2>

          <iframe
           title="Amphigreen Office Location"
           src={`https://www.google.com/maps?q=${encodeURIComponent( "1104, Tolstoy House, Atul Grove Road, Janpath, Connaught Place, New Delhi, Delhi 110001")}&output=embed`}
           width="100%"
           height="260"
           style={{ border: 0, borderRadius: "10px" }}
           allowFullScreen=""
           loading="lazy"
          ></iframe>

          <div className="office-hours">
            <h3>Office Hours</h3>
            <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
            <p>Saturday: 10:00 AM - 4:00 PM</p>
            <p>Sunday: Closed</p>
          </div>
        </div>
      </section>
    </div>
  );
}
